import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function PreviewFailure({ error, onRetry }) {
  const { lang } = useLanguage();
  const et = lang === 'et';
  return <div role="alert" style={{ padding: '5rem 1.5rem 1.5rem', color: '#f3f4f6', textAlign: 'left' }}>
    <h2 style={{ fontSize: '1.1rem' }}>{et ? '3D-vaate laadimine ebaõnnestus' : 'Could not load the 3D view'}</h2>
    <p>{et ? 'Ukse valikud on alles. Proovi 3D-vaade uuesti laadida.' : 'Your door settings have been kept. Try loading the 3D view again.'}</p>
    {error && <p style={{ color: '#fbbf24', overflowWrap: 'anywhere', fontSize: '0.85rem' }}>
      {et ? 'Vea kirjeldus: ' : 'Error details: '}{String(error).slice(0, 300)}
    </p>}
    <button type="button" onClick={onRetry} style={{ background: '#dfa926', color: '#111', border: 0, borderRadius: 6, padding: '0.6rem 1rem', cursor: 'pointer' }}>
      {et ? 'Laadi 3D-vaade uuesti' : 'Retry 3D view'}
    </button>
  </div>;
}
